document.addEventListener('DOMContentLoaded', function() {
    // Check if popup should be shown based on conditions
    function checkAndShowPopup() {
        const affiliateCode = localStorage.getItem('affiliateCode');
        const klaviyoData = localStorage.getItem('klaviyoOnsite');
        
        // Check if Klaviyo form was previously shown or closed
        let shouldShowForm = true;
        
        // Check session storage for dismissed popups
        const sessionDismissed = sessionStorage.getItem('klaviyoPopupDismissed');
        if (sessionDismissed === 'true') {
            shouldShowForm = false;
            console.log('Popup not shown - was dismissed earlier this session');
        }
        
        if (klaviyoData) {
            try {
                const klaviyoObj = JSON.parse(klaviyoData);
                const formData = klaviyoObj.viewedForms?.modal;
                
                // Check if either form was viewed or disabled
                if (formData?.viewedForms?.XNF7F7 || formData?.disabledForms?.XNF7F7 ||
                    formData?.viewedForms?.VCdP5b || formData?.disabledForms?.VCdP5b) {
                    shouldShowForm = false;
                }
            } catch (e) {
                console.error('Error parsing Klaviyo data:', e);
            }
        }

        // Show forms based on conditions
        if (shouldShowForm) {
            if (!affiliateCode || affiliateCode === 'STSMD') {
                if (window.innerWidth <= 768) {
                    window._klOnsite.push(['openForm', 'VCdP5b']); // Regular mobile form
                } else {
                    window._klOnsite.push(['openForm', 'XNF7F7']); // Regular desktop form
                }
            }
        }
    }

    // Scroll trigger - show popup when user scrolls 15% of the page
    let popupTriggered = false;
    
    function handleScroll() {
        if (popupTriggered) return;
        
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const documentHeight = document.documentElement.scrollHeight - window.innerHeight;
        const scrollPercentage = (scrollTop / documentHeight) * 100;
        
        if (scrollPercentage >= 15) {
            console.log('User scrolled 15% - triggering popup check');
            popupTriggered = true;
            window.removeEventListener('scroll', handleScroll);
            checkAndShowPopup();
        }
    }
    
    // Add scroll listener. Passive: it never calls preventDefault.
    window.addEventListener('scroll', handleScroll, { passive: true });

    /* Button handlers. These used to be attached by a MutationObserver on the
       whole of document.body (subtree, never disconnected) that re-scanned
       every <button> on each DOM change, plus a 100ms scan at load. Now one
       capture-phase listener attaches the same handler to a button when it is
       first clicked. A listener added to a node before the event reaches it
       still runs for that event (DOM dispatch), so each handler runs exactly
       where it did before: on the button, after the button's own listeners,
       and its stopPropagation still keeps the click from Klaviyo's own handler
       and from the click-outside handler below. */
    function attachSignUp(signUpButton) {
        signUpButton.addEventListener('click', () => {
            const emailInput = document.querySelector('input[type="email"]');
            const zipInput = document.querySelector('input[name="zip"]');

            if (emailInput?.value) {
                try { localStorage.setItem('customerEmail', emailInput.value); } catch (e) { /* storage full or blocked */ }
                console.log('Email saved from button click:', emailInput.value);
            }

            if (zipInput?.value) {
                try { localStorage.setItem('customerZip', zipInput.value); } catch (e) { /* storage full or blocked */ }
                console.log('Zip code saved from button click:', zipInput.value);
            }

            console.log('Button click data:', {
                email: emailInput?.value || 'not provided',
                zipCode: zipInput?.value || 'not provided'
            });
        });
        signUpButton.dataset.listenerAttached = 'true';
    }

    function attachClose(button, message) {
        button.addEventListener('click', (e) => {
            console.log(message);
            try { sessionStorage.setItem('klaviyoPopupDismissed', 'true'); } catch (e) { /* storage full or blocked */ }

            // Actually close the Klaviyo form
            if (window._klOnsite) {
                window._klOnsite.push(['closeForm']);
            }

            // Fallback: try to hide the form container directly
            const formContainer = button.closest('[role="dialog"]');
            if (formContainer) {
                formContainer.style.display = 'none';
            }

            // Prevent default behavior
            e.preventDefault();
            e.stopPropagation();
        });
        button.dataset.listenerAttached = 'true';
    }

    /* Klaviyo's own markup. Its renderer gives EVERY element it draws the class
       kl-private-reset-css-Xuajs1 (plus needsclick); embedded forms mount in a
       klaviyo-form-XXXX root. The theme and the other apps use none of these, so
       a "No thanks" or a modal outside them is not Klaviyo's and is left alone.
       Until 2026-09-22 this matched ANY button reading "No thanks" and the FIRST
       aria-modal dialog on the page, which caught the theme's buy-anyway / quick
       view confirms and, on Escape, LlamaCart's drawer. */
    const KLAVIYO_SCOPE = '[class*="kl-private-reset-css"], [class^="klaviyo-form-"], [class*=" klaviyo-form-"]';
    const KLAVIYO_MODAL = '[role="dialog"][aria-modal="true"][class*="kl-private-reset-css"]';
    /* Click-outside acts only on Klaviyo's page-locking popups, where "outside"
       is the overlay; a flyout does not lock the page and is left to its own X. */
    const KLAVIYO_POPUP = '[role="dialog"][aria-modal="true"][data-kl-scroll-locking-modal][class*="kl-private-reset-css"]';

    document.addEventListener('click', function (e) {
        const button = e.target && e.target.closest ? e.target.closest('button') : null;
        if (!button || button.dataset.listenerAttached) return;

        // Same precedence as before: the (first) sign-up button, then close, then "No thanks".
        if (button === document.querySelector('button.needsclick.go3594183497')) {
            attachSignUp(button);
        } else if (button.matches('button.klaviyo-close-form')) {
            attachClose(button, 'Popup closed by user - storing in session');
        } else if (button.textContent && button.textContent.includes("No thanks") && button.closest(KLAVIYO_SCOPE)) {
            attachClose(button, 'No thanks button clicked - closing popup');
        }
    }, true);

    // Add keyboard and click-outside handlers for additional close options
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
            const klaviyoForm = document.querySelector(KLAVIYO_MODAL);
            if (klaviyoForm && klaviyoForm.style.display !== 'none') {
                console.log('Escape key pressed - closing Klaviyo popup');
                try { sessionStorage.setItem('klaviyoPopupDismissed', 'true'); } catch (e) { /* storage full or blocked */ }
                
                if (window._klOnsite) {
                    window._klOnsite.push(['closeForm']);
                }
                
                klaviyoForm.style.display = 'none';
            }
        }
    });

    // Click outside to close
    document.addEventListener('click', function(e) {
        const klaviyoForm = document.querySelector(KLAVIYO_POPUP);
        if (klaviyoForm && klaviyoForm.style.display !== 'none') {
            const formContent = klaviyoForm.querySelector('form');
            if (formContent && !formContent.contains(e.target) && !e.target.closest('button.klaviyo-close-form')) {
                console.log('Clicked outside form - closing Klaviyo popup');
                try { sessionStorage.setItem('klaviyoPopupDismissed', 'true'); } catch (e) { /* storage full or blocked */ }
                
                if (window._klOnsite) {
                    window._klOnsite.push(['closeForm']);
                }
                
                klaviyoForm.style.display = 'none';
            }
        }
    });

    // Keep existing Klaviyo success handler as backup
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['addSubmitHandler', function(data) {
        const email = data?.email;
        const zipCode = document.querySelector('input[name="zip"]')?.value;
        
        if (email) {
            try { localStorage.setItem('customerEmail', email); } catch (e) { /* storage full or blocked */ }
            console.log('Email saved from Klaviyo callback:', email);
        }
        
        if (zipCode) {
            try { localStorage.setItem('customerZip', zipCode); } catch (e) { /* storage full or blocked */ }
            console.log('Zip code saved:', zipCode);
        }

        console.log('Form submission data:', {
            email: email || 'not provided',
            zipCode: zipCode || 'not provided'
        });
    }]);

    // Listen for Klaviyo form closures
    window._klOnsite.push(['addEventHandler', 'closeForm', function(data) {
        console.log('Klaviyo form closed event detected');
        try { sessionStorage.setItem('klaviyoPopupDismissed', 'true'); } catch (e) { /* storage full or blocked */ }
    }]);
}); 